import { render } from "./Reloader.vue?vue&type=template&id=3457db68"
import script from "./Reloader.vue?vue&type=script&lang=js"
export * from "./Reloader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__